export default __webpack_public_path__ + "static/media/icon-all-nfts.3f5afe6a.svg";